import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private collapsedState = new BehaviorSubject<boolean>(false); // Initial state: not collapsed

  sidebarState$ = this.collapsedState.asObservable(); // Expose as Observable

  private activeRoute = new BehaviorSubject<string>(''); // Track active route

  activeRoute$ = this.activeRoute.asObservable(); // Expose active route as Observable

  toggleSidebar() {
    this.collapsedState.next(!this.collapsedState.value); // Toggle state
  }

  setActiveRoute(route: string) {
    this.activeRoute.next(route); // Update the active route
  }
}
